import { render } from "./ClientConfiguracionImpresiones.vue?vue&type=template&id=b5ea5276&scoped=true"
import script from "./ClientConfiguracionImpresiones.vue?vue&type=script&lang=js"
export * from "./ClientConfiguracionImpresiones.vue?vue&type=script&lang=js"

import "./ClientConfiguracionImpresiones.vue?vue&type=style&index=0&id=b5ea5276&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5ea5276"]])

export default __exports__